import { render, staticRenderFns } from "./HomeFour.vue?vue&type=template&id=068983fe&scoped=true&"
import script from "./HomeFour.vue?vue&type=script&lang=js&"
export * from "./HomeFour.vue?vue&type=script&lang=js&"
import style0 from "./HomeFour.vue?vue&type=style&index=0&id=068983fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068983fe",
  null
  
)

export default component.exports